import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import uploadBlobPDF from "./uploadPDF";

function getTargetRef({ eventId, ticketId }) {
  if (ticketId) {
    return doc(db, "Events", eventId, "Tickets", ticketId);
  }

  return doc(db, "Events", eventId);
}

function getTemplateUploadPath({ eventId, ticketId }) {
  if (ticketId) {
    return `events/${eventId}/tickets/${ticketId}/template`;
  }

  return `events/${eventId}/templates/global`;
}

async function updateEventWitchCustomizeTicket({ eventId, customizeTicketsDetails, ticketId }) {
  try {
    const targetRef = getTargetRef({ eventId, ticketId });

    if (customizeTicketsDetails !== null) {
      let customTemplatePath = customizeTicketsDetails.pdf;

      if (customTemplatePath && customTemplatePath instanceof Blob) {
        customTemplatePath = await uploadBlobPDF(
          customTemplatePath,
          getTemplateUploadPath({ eventId, ticketId }),
        );
      }

      await updateDoc(targetRef, {
        customTicketConfiguration: {
          x: customizeTicketsDetails.x,
          y: customizeTicketsDetails.y,
          size: customizeTicketsDetails.size,
          templatePath: customTemplatePath,
        },
      });

      return customTemplatePath;
    } else {
      await updateDoc(targetRef, {
        customTicketConfiguration: null,
      });
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export default updateEventWitchCustomizeTicket;
